import React from 'react';
import '../components/Terms.css'; // Make sure this path is correct!

const TermsAndConditions = () => (
  <div className="terms-container">
    <h1 className="terms-title">Terms and Conditions</h1>
    
    <p>
      Welcome to Pranayuv Technologies Private Limited (“Pranayuv”, “We”, “Us”, “Our”, or the “Company”). These Terms and Conditions (“Terms”) govern your access to and use of our website and services (collectively, the “Services”).
    </p>
    <p>
      By accessing or using the Platform or its Services, you agree to be bound by these Terms. If you do not agree, you must discontinue using the Services immediately. Your continued use constitutes acceptance of these Terms, which may be updated from time to time.
    </p>

    <hr />

    <h2 className="terms-section-title">1. Definitions</h2>
    <ul>
      <li><b>Company:</b> Pranayuv Technologies Private Limited, its affiliates, and subsidiaries.</li>
      <li><b>Website:</b> All digital platforms owned, operated, or managed by the Company, including <a href="http://www.pranayuv.com" target="_blank" rel="noopener noreferrer">www.pranayuv.com</a> and its subdomains.</li>
      <li><b>Services:</b> Online tools, e-commerce functionalities, reservation systems, and customer support provided through the Website.</li>
      <li><b>User:</b> Any individual or entity accessing or using the Services.</li>
      <li><b>Products:</b> The health care and associated services offered by the Company.</li>
      <li><b>Content:</b> All text, images, videos, and other multimedia provided on the Website or through the Services.</li>
    </ul>

    <h2 className="terms-section-title">2. Eligibility to Use</h2>
    <ul>
      <li><b>Age Requirement:</b> You must be at least 18 years old to use our Services. If you are a minor, transactions must be carried out by your legal guardian or parent on your behalf.</li>
      <li><b>Authority to Act:</b> If you use the Services on behalf of an organization, you warrant you have the authority to bind such entity.</li>
      <li><b>Compliance with Laws:</b> You agree to comply with all applicable laws, regulations, and guidelines while using our Services.</li>
    </ul>

    <h2 className="terms-section-title">3. User Obligations</h2>
    <ul>
      <li>Provide accurate, complete, and up-to-date information.</li>
      <li>Maintain the confidentiality of your account credentials.</li>
      <li>Do not use the Services for unlawful purposes or to disrupt the Website.</li>
      <li>Do not attempt unauthorized access to any part of the Website.</li>
      <li>Do not upload or transmit malicious software or harmful content.</li>
      <li>Respect the intellectual property rights of the Company and others.</li>
    </ul>

    <h2 className="terms-section-title">4. Intellectual Property Rights</h2>
    <ul>
      <li>All content, trademarks, logos, designs, graphics, images, and text are the exclusive property of Pranayuv Technologies Private Limited or its licensors.</li>
      <li>You are granted a non-exclusive, non-transferable, revocable license to access and use the Website and Services strictly in accordance with these Terms.</li>
      <li>Do not modify, copy, reproduce, or distribute any Content without prior written consent.</li>
    </ul>

    <h2 className="terms-section-title">5. Pricing and Payments</h2>
    <ul>
      <li>Product prices are subject to change at the Company’s discretion without prior notice.</li>
      <li>Payments are accepted through authorized third-party gateways. By paying, you agree to their terms.</li>
      <li>Order confirmation will be sent upon successful payment. Orders may be cancelled due to pricing errors, stock issues, or unforeseen circumstances.</li>
      <li>Refunds, returns, cancellations, shipping, and warranties are governed by the Company’s Service Policies, accessible on the Website.</li>
    </ul>

    <h2 className="terms-section-title">6. User Responsibilities</h2>
    <ul>
      <li>Comply with all applicable local, state, national, and international laws and regulations.</li>
      <li>Maintain the confidentiality of your account credentials and notify the Company of any unauthorized access.</li>
      <li>Do not upload harmful, offensive, or illegal content.</li>
      <li>Do not attempt to access restricted areas or use the Website for fraudulent purposes.</li>
      <li>Do not manipulate or interfere with the Website’s content or functionality.</li>
    </ul>

    <h2 className="terms-section-title">7. Third-Party Services and Links</h2>
    <ul>
      <li>The Website may provide links to third-party websites or services, governed by their own terms and privacy policies.</li>
      <li>Inclusion of such links does not imply endorsement by the Company.</li>
      <li>Access third-party services at your own risk; the Company is not liable for any resulting loss or damage.</li>
    </ul>

    <h2 className="terms-section-title">8. Disclaimers and Limitation of Liability</h2>
    <ul>
      <li>The Website and its content are provided “as is” and “as available” without warranties of any kind.</li>
      <li>The Company is not liable for indirect, incidental, special, consequential, or punitive damages.</li>
      <li>The Company’s total liability shall not exceed the amount paid by you in the past three months for accessing the Website or services.</li>
      <li>The Company is not liable for any third-party actions or content.</li>
    </ul>

    <h2 className="terms-section-title">9. Indemnification</h2>
    <ul>
      <li>You agree to indemnify and hold harmless the Company and its affiliates from any claims, damages, or losses arising from your violation of these Terms or misuse of the Website.</li>
    </ul>

    <h2 className="terms-section-title">10. Termination</h2>
    <ul>
      <li>The Company reserves the right to terminate or suspend your access to the Website or services for any reason, including breach of these Terms.</li>
      <li>Upon termination, all rights granted to you will cease, and you must stop using the Website and services.</li>
      <li>The Company will not be liable for any loss or damage arising from termination.</li>
    </ul>

    <h2 className="terms-section-title">11. Governing Law and Jurisdiction</h2>
    <ul>
      <li>These Terms are governed by the laws of India.</li>
      <li>Any disputes shall be subject to the exclusive jurisdiction of the courts located in Vijayawada, Andhra Pradesh.</li>
      <li>Users accessing the Website from outside India do so at their own risk and are responsible for compliance with local laws.</li>
    </ul>

    <h2 className="terms-section-title">12. Force Majeure</h2>
    <ul>
      <li>The Company is not liable for failure or delay in performance due to events beyond its control, including but not limited to natural disasters, war, government actions, or telecom failures.</li>
    </ul>

    <h2 className="terms-section-title">13. Severability</h2>
    <p>
      If any part of these Terms is found to be invalid or unenforceable, the remaining provisions will remain in effect.
    </p>

    <h2 className="terms-section-title">14. Entire Agreement</h2>
    <p>
      These Terms, together with any documents incorporated herein, constitute the entire agreement between you and the Company regarding the use of the Website and its services.
    </p>

    <h2 className="terms-section-title">15. Contact Us</h2>
    <p>
      For any questions or clarifications, please contact us at: <a href="mailto:info@pranayuv.com">info@pranayuv.com</a>
    </p>

    <h2 className="terms-section-title">16. Updates to Terms</h2>
    <p>
      The Company reserves the right to update these Terms at any time. Updates will be effective immediately upon posting on this website. Continued use of the website constitutes acceptance of the updated Terms.
    </p>
  </div>
);

export default TermsAndConditions;
